import { ReactNode } from 'react'
import styled, { CSSObject } from '@emotion/styled'
import { FusionColor } from '../../../theme/FusionStyle'

interface ValueLabelProps {
	size?: 'max'
	color?: FusionColor
}

const ValueLabel = styled.label<ValueLabelProps>(({theme, size, color}) => {
	const style: CSSObject = {
		font: 'inherit',
	}
	switch(size) {
		case 'max':
			style.font = `normal 1.5rem ${theme.fonts.title.fontFamily}`
			break
	}
	if(color) {
		style.color = theme.colors[color]
	}
	return style
})

interface L1ValueLabelProps extends ValueLabelProps {
	children?: ReactNode
}

const L1ValueLabel = ({size, color, children}: L1ValueLabelProps) => {
	return (
		<ValueLabel size={size} color={color}>{children}</ValueLabel>
	)
}

export default L1ValueLabel
